<template>
    <div id="uploadImage">
        <a-row type="flex" justify="start" class="mt">
            <a-col class="ml4">
                <a-upload
                        name="file"
                        :showUploadList="false"
                        :headers="headers"
                        :data="uploadData"
                        :multiple="true"
                        method="post"
                        :customRequest="customRequest"
                >
                    <a-button type="primary" shape="circle" icon="upload" size="small"/>
                </a-upload>
            </a-col>
            <a-col class="ml4">
                <a-popconfirm
                        :title="$t('generic.AreyoudeleTask')"
                        @confirm="delImage"
                        :okText="$t('generic.Yes')"
                        :cancelText="$t('generic.No')"
                >
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span>{{$t('pubGicSet.Remove')}}</span>
                        </template>
                        <img class="sbxs" src="../../../../assets/img/ss-delete.png" width="22" height="22">
                    </a-tooltip>
                </a-popconfirm>
            </a-col>
        </a-row>
        <a-row class="mt4">
            <vxe-table
                    border
                    resizable
                    highlight-hover-row
                    size="mini"
                    :data="tableData"
                    ref="imageTableRef">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="imgName" title="Image Name" minWidth="150"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="filePath" title="Path" minWidth="150"></vxe-table-column>
                <vxe-table-column title="" width="100" show-overflow>
                    <template v-slot="{ row }">
                        <a-button type="link" size="small" @click="dowmImage(row)">Download</a-button>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </a-row>
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import axios from 'axios'
    import cookie from "../../../../api/cookie";
    export default{
        props:{
            dataSourceRow: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            headerUid:{
                type: String,
                default: function() {
                    return '';
                }
            }
        },
        data(){
            return{
                tableData: [],
                headers: {
                    Authorization: cookie.getBearerToken(),
                },
                action: '',
                uploadData:{}
            }
        },
        watch:{
            dataSourceRow(v){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods:{
            init(){
                ajax.get(api.REPORTGENERICCONFIGIREPORTIMAGE,{rtIreportUid:  this.dataSourceRow.uid}).then(res=>{
                    this.tableData = res.data
                })
            },
            delImage(){
                let arr = this.$refs.imageTableRef.getCheckboxRecords()
                if(arr.length > 0){
                    let params = {uids: []}
                    for(let i in arr){params.uids.push(arr[i].uid)}
                    ajax.post(api.REPORTGENERICDELCONFIGIREPORTIMAGE,params).then(res=>{
                        if(res.code == 200){
                            this.init()
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'))
                }
            },
            customRequest(data){
                const formData = new FormData()
                formData.append('file', data.file)
                formData.append('uid', this.dataSourceRow.uid)
                this.$store.commit("updataLoading", { pbLoading: true });
                ajax.post(api.REPORTGENERICCONFIGIMAGEUPLOAD,formData).then(res=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    if(res.code == '200'){
                        this.$message.success(res.msg);
                        this.init()
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            dowmImage(row){
                let ajaxurl = ajax.ajaxUrl();
                axios.get(ajaxurl + api.REPORTGENERICCONFIGIMAGEDOWNLOAD, {
                    params: {
                        uid:row.uid,
                    },
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
                    let blob = new Blob([res.data], {type: "application/octet-stream;charset=UTF-8"});
                    let url = window.URL.createObjectURL(blob);
                    let aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download", row.imgName);
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                })
            }
        }
    }
</script>
